import { ShoppingCart, Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const Navbar = ({ cartCount }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav data-testid="navbar" className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-24 md:h-28">
          <Link to="/" data-testid="navbar-logo" className="flex items-center space-x-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_essence-store-24/artifacts/hjaqgh6o_Screenshot_20260219_..._imresizer.jpg" 
              alt="Krishna Sugandh" 
              className="h-16 md:h-20 w-auto"
            />
            <div className="hidden md:block">
              <div className="font-prestige text-2xl text-primary">
                KRISHNA SUGANDH
              </div>
              <div className="text-[10px] text-muted-foreground tracking-[0.3em] uppercase mt-1">
                Est. 2007 · Kannauj
              </div>
            </div>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              data-testid="nav-link-home"
              className={`text-sm uppercase tracking-widest transition-colors duration-300 font-body ${
                isActive('/') ? 'text-primary' : 'text-foreground hover:text-primary'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/products" 
              data-testid="nav-link-products"
              className={`text-sm uppercase tracking-widest transition-colors duration-300 font-body ${
                isActive('/products') ? 'text-primary' : 'text-foreground hover:text-primary'
              }`}
            >
              Products
            </Link>
            <Link 
              to="/wholesale" 
              data-testid="nav-link-wholesale"
              className={`text-sm uppercase tracking-widest transition-colors duration-300 font-body ${
                isActive('/wholesale') ? 'text-primary' : 'text-foreground hover:text-primary'
              }`}
            >
              Wholesale
            </Link>
            <Link 
              to="/about" 
              data-testid="nav-link-about"
              className={`text-sm uppercase tracking-widest transition-colors duration-300 font-body ${
                isActive('/about') ? 'text-primary' : 'text-foreground hover:text-primary'
              }`}
            >
              About
            </Link>
            <Link 
              to="/contact" 
              data-testid="nav-link-contact"
              className={`text-sm uppercase tracking-widest transition-colors duration-300 font-body ${
                isActive('/contact') ? 'text-primary' : 'text-foreground hover:text-primary'
              }`}
            >
              Contact
            </Link>
            <Link 
              to="/track-order" 
              data-testid="nav-link-track"
              className={`text-sm uppercase tracking-widest transition-colors duration-300 font-body ${
                isActive('/track-order') ? 'text-primary' : 'text-foreground hover:text-primary'
              }`}
            >
              Track Order
            </Link>
            <Link 
              to="/cart" 
              data-testid="nav-cart-link"
              className="relative"
            >
              <ShoppingCart className="w-6 h-6 text-foreground hover:text-primary transition-colors duration-300" strokeWidth={1.5} />
              {cartCount > 0 && (
                <span data-testid="cart-count-badge" className="absolute -top-2 -right-2 bg-primary text-primary-foreground w-5 h-5 rounded-full flex items-center justify-center text-xs font-medium">
                  {cartCount}
                </span>
              )}
            </Link>
          </div>

          <button 
            data-testid="mobile-menu-toggle"
            onClick={() => setIsOpen(!isOpen)} 
            className="md:hidden text-foreground"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-background/95 backdrop-blur-xl border-t border-white/5"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-4 space-y-4">
              <Link to="/" data-testid="mobile-nav-home" className="block text-sm uppercase tracking-widest" onClick={() => setIsOpen(false)}>
                Home
              </Link>
              <Link to="/products" data-testid="mobile-nav-products" className="block text-sm uppercase tracking-widest" onClick={() => setIsOpen(false)}>
                Products
              </Link>
              <Link to="/wholesale" data-testid="mobile-nav-wholesale" className="block text-sm uppercase tracking-widest" onClick={() => setIsOpen(false)}>
                Wholesale
              </Link>
              <Link to="/about" data-testid="mobile-nav-about" className="block text-sm uppercase tracking-widest" onClick={() => setIsOpen(false)}>
                About
              </Link>
              <Link to="/contact" data-testid="mobile-nav-contact" className="block text-sm uppercase tracking-widest" onClick={() => setIsOpen(false)}>
                Contact
              </Link>
              <Link to="/track-order" data-testid="mobile-nav-track" className="block text-sm uppercase tracking-widest" onClick={() => setIsOpen(false)}>
                Track Order
              </Link>
              <Link to="/cart" data-testid="mobile-nav-cart" className="flex items-center space-x-2 text-sm uppercase tracking-widest" onClick={() => setIsOpen(false)}>
                <ShoppingCart size={18} />
                <span>Cart ({cartCount})</span>
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};